import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Treatments from "./components/Treatments";
import Team from "./components/Team";
import Philosophy from "./components/Philosophy";
import Testimonials from "./components/Testimonials";
import Location from "./components/Location";
import BookCTA from "./components/BookCTA";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

const Home = () => (
  <div className="bg-[#fbf9f4] min-h-screen">
    <Navbar />
    <Hero />
    <Marquee />
    <About />
    <Treatments />
    <Team />
    <Philosophy />
    <Testimonials />
    <Location />
    <BookCTA />
    <Footer />
    <WhatsAppFloat />
    <Toaster />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
